import * as React from 'react'
import { ICoordinates, IMarker, IZoneObject, IActiveTripResponseV2, IServiceDesignatedHotspot } from '../../types'
import { Circle, GoogleMap, Marker, Polygon, Polyline, withGoogleMap, CircleProps } from 'react-google-maps'
// @ts-ignore
import { IRenderConditions } from '../MapView'
import { LocationTypes } from '../../constants/trip'

import * as CarIcon from '../../components/icons/google-map/CarIcon.svg'
import * as dropOffMarker from '../../components/icons/google-map/DropOffIcon.svg'
import * as pickUpMarker from '../../components/icons/google-map/PickUpIcon.svg'
import * as locationMarker from '../../components/icons/google-map/PointIcon.svg'

interface IGoogleMapComponentProps {
  origin: ICoordinates | null
  destination: ICoordinates | null
  location: IServiceDesignatedHotspot
  locationType: string | undefined
  center?: ICoordinates
  zoom: number
  markers?: IMarker[]
  polygon?: ICoordinates[] | null
  zone?: IZoneObject | null
  zones?: { [key: string]: IZoneObject } | null
  zoneId?: string
  circles?: CircleProps[]
  onMapMounted: any
  decodedPolyline: any
  renderStrategy: IRenderConditions
  isDraggable: boolean
  isModal?: boolean
  currentTrip?: IActiveTripResponseV2
  onOriginPinChanged?: (event: google.maps.MouseEvent) => void
  onDestPinChanged?: (event: google.maps.MouseEvent) => void
  selectLocation?: (event: google.maps.MouseEvent) => void
}

const renderMarkers = (props: IGoogleMapComponentProps) => {
  if (!props.markers) {
    return null
  }

  return props.markers.map((m, index) => {
    if (m.type === 'origin' && props.renderStrategy.isShowOrigin) {
      return (
        <Marker
          key={`marker-${index}`}
          position={m}
          draggable={false}
          onDragEnd={props.onOriginPinChanged}
          icon={{ url: pickUpMarker.toString() }}
          title={m.title}
        />
      )
    } else if (m.type === 'destination' && props.renderStrategy.isShowDestination) {
      return (
        <Marker
          key={`marker-${index}`}
          position={m}
          draggable={false}
          onDragEnd={props.onDestPinChanged}
          icon={{ url: dropOffMarker.toString() }}
          title={m.title}
        />
      )
    } else if (m.type === 'car' && props.renderStrategy.isShowCars) {
      return (
        <Marker
          draggable={false}
          icon={{ url: CarIcon.toString() }}
          key={`markerWithLabel-${index}`}
          label={{ text: m.title }}
          labelAnchor={new google.maps.Point(0, 0)}
          position={m}
          title={m.title}
        />
      )
    } else {
      return null
    }
  })
}

const ServiceDesignatedHotspotGoogleMapComponent = withGoogleMap((props: IGoogleMapComponentProps) => {
  const { color, shape, shapeType } = props.location || null
  const polygonCoordinates =
    shape && shape.coordinates && shape.coordinates[0] && shape.coordinates[0][0]
      ? shape.coordinates[0][0].map(coordinate => ({ lat: coordinate[1], lng: coordinate[0] }))
      : null

  const locationIcon =
    props.locationType === LocationTypes.PICKUP
      ? pickUpMarker
      : props.locationType === LocationTypes.DROPOFF
      ? dropOffMarker
      : locationMarker
  const zonePath = props.zone
    ? props.zone.shape
      ? props.zone.shape.coordinates[0][0].map(ps => ({ lat: ps[1], lng: ps[0] }))
      : []
    : []

  const zonePaths: Array<{
    detail: { color: string; visible: boolean | undefined }
    coordinates:
      | google.maps.MVCArray<google.maps.MVCArray<google.maps.LatLng>>
      | google.maps.MVCArray<google.maps.LatLng>
      | Array<Array<google.maps.LatLng | google.maps.LatLngLiteral>>
      | Array<google.maps.LatLng | google.maps.LatLngLiteral>
  }> = []

  const zoneCircle: Array<{
    detail: { color: string; visible: boolean | undefined }
    cordinate: { center: { lat: number; lng: number }; radius: number }
  }> = []

  const showPolygonMapServiceZones = (zone: IZoneObject) => {
    if (!props.currentTrip && (zone.shapeType === 'shape_polygon' || zone.shapeType === 'shape_multipolygon')) {
      return true
    }
    if (
      props.currentTrip &&
      (zone.shapeType === 'shape_polygon' || zone.shapeType === 'shape_multipolygon') &&
      zone.serviceId === props.currentTrip.service.serviceId
    ) {
      return true
    }
    return false
  }
  const showCircleMapSeriviceZones = (zone: IZoneObject) => {
    if (!props.currentTrip && zone.shapeType === 'shape_circle') {
      return true
    }
    if (
      props.currentTrip &&
      zone.shapeType === 'shape_circle' &&
      zone.serviceId === props.currentTrip.service.serviceId
    ) {
      return true
    }
    return false
  }

  if (props.zones) {
    Object.keys(props.zones).forEach(element => {
      if (props.zones && props.zones[element]) {
        const zone = props.zones[element]
        if (showPolygonMapServiceZones(zone)) {
          const coordinates = zone ? (zone.shape ? zone.shape.coordinates[0] : []) : []

          const paths = coordinates.map(coord => coord.map(ps => ({ lat: ps[1], lng: ps[0] })))
          zonePaths.push({ detail: { color: zone.color, visible: zone.visible }, coordinates: paths })
        }

        if (showCircleMapSeriviceZones(zone)) {
          zoneCircle.push({
            detail: { color: zone.color, visible: zone.visible },
            cordinate: {
              center: {
                lat: zone.center ? zone.center.coordinates[0] : 0,
                lng: zone.center ? zone.center.coordinates[1] : 0
              },
              radius: zone.radius || 0
            }
          })
        }
      }
    })
  }

  return (
    <GoogleMap
      ref={props.onMapMounted}
      options={{
        mapTypeControl: true,
        streetViewControl: false,
        mapTypeControlOptions: {
          mapTypeIds: ['roadmap', 'satellite']
        }
      }}
      mapTypeId={props.isModal ? 'satellite' : 'roadmap'}
      zoom={props.isModal ? 18 : props.zoom}
      defaultCenter={props.center}
      // onBoundsChanged={props.onBoundsChanged}
    >
      {renderMarkers(props)}
      {console.log('PROPS renderMarker', props.location)}
      {props.location && (!props.origin && !props.destination) && (
        <Marker
          position={props.location.coordinates}
          draggable={props.isDraggable}
          onDragEnd={props.selectLocation}
          icon={{ url: locationIcon.toString() }}
        />
      )}

      {props.currentTrip &&
        zoneCircle.map(circle => (
          <Circle
            center={{ lat: circle.cordinate.center.lng, lng: circle.cordinate.center.lat }}
            radius={circle.cordinate.radius}
            options={{
              strokeColor: circle.detail.color,
              strokeOpacity: 0.5,
              strokeWeight: 2,
              fillOpacity: 0.3,
              fillColor: circle.detail.color
            }}
          />
        ))}

      {props.currentTrip &&
        zonePaths.map(zonePath => (
          <Polygon
            paths={zonePath.coordinates}
            options={{
              strokeColor: zonePath.detail.color,
              strokeOpacity: 0.5,
              strokeWeight: 2,
              fillOpacity: 0.3,
              fillColor: zonePath.detail.color
            }}
          />
        ))}

      {props.circles &&
        props.circles.length &&
        props.circles.map((circleProps: CircleProps, idx) => <Circle {...circleProps} key={idx} />)}
      {props.decodedPolyline && props.renderStrategy.isShowPolyline && (
        <Polyline
          path={props.decodedPolyline}
          options={{
            strokeColor: '#38B44F',
            strokeOpacity: 0.7,
            strokeWeight: 3
          }}
        />
      )}
      {props.zone && (
        <Polygon
          options={{
            strokeOpacity: 0.5,
            strokeWeight: 2,
            fillOpacity: 0.1,
            fillColor: props.zone ? props.zone.color : ''
          }}
          path={zonePath}
        />
      )}

      {zonePaths.map(
        (name, index) =>
          name.detail.visible && (
            <Polygon
              key={`map-zone-polygon-${index}`}
              options={{
                strokeOpacity: 0.5,
                strokeWeight: 2,
                fillOpacity: 0.35,
                fillColor: name.detail.color
              }}
              paths={name.coordinates}
            />
          )
      )}

      {zoneCircle.map(
        (name, index) =>
          name.detail.visible && (
            <Circle
              key={`map-zone-circle-${index}`}
              center={{ lat: name.cordinate.center.lng, lng: name.cordinate.center.lat }}
              radius={name.cordinate.radius}
              options={{
                strokeColor: name.detail.color,
                strokeOpacity: 0.5,
                strokeWeight: 2,
                fillOpacity: 0.3,
                fillColor: name.detail.color
              }}
            />
          )
      )}

      {shapeType === 'shape_multipolygon' && polygonCoordinates && (
        <Polygon
          options={{
            strokeColor: color,
            strokeOpacity: 0.5,
            strokeWeight: 2,
            fillOpacity: 0.35,
            fillColor: color
          }}
          paths={polygonCoordinates}
        />
      )}
    </GoogleMap>
  )
})

export default ServiceDesignatedHotspotGoogleMapComponent



// WEBPACK FOOTER //
// ./src/components/google-map/ServiceDesignatedHotspotGoogleMap.tsx